// Default toast duration when not specified is
// - blank	4000
// - error	4000
// - success	2000
// Default toast Position when not specified is top-center

import { ToastPosition } from "react-hot-toast"

export const DEFAULT_TOAST_CONFIG = {
  duration: 6000,
  className: 'dark:bg-lightViolet dark:text-white border border-white dark:border-gray-700',
}

export const BOTTOM_TOAST_CONFIG = {
  duration: 6000,
  className: 'dark:bg-lightViolet dark:text-white border border-white dark:border-gray-700',
  position: 'bottom-center' as ToastPosition
}

export const SHORT_TOAST_CONFIG = {
  className: 'dark:bg-lightViolet dark:text-white border border-white dark:border-gray-700',
}
